import {
  FiltersStoreAction,
  FiltersStoreKind,
  FiltersStoreType,
} from './filtersStore.types';

export const INITIAL_FILTERS: FiltersStoreType = {
  searchTerm: '',
  region: [],
  country: [],
  sector: [],
  sector2: [],
  typeOfProjectPartner: [],
  ratingMin: 1,
  ratingMax: 6,
  size: 25,
  page: 0,
  sort: 'evaluationYear,DESC',
};

const filtersStore = (
  state: FiltersStoreType,
  action: FiltersStoreAction
): FiltersStoreType => {
  switch (action.type) {
    case FiltersStoreKind.INITIAL: {
      return { ...state, ...action.payload };
    }
    case FiltersStoreKind.UPDATE_RATING:
      return {
        ...state,
        ratingMin: action.payload.ratingMin,
        ratingMax: action.payload.ratingMax,
        page: 0,
      };
    case FiltersStoreKind.UPDATE_DROPDOWN:
      return {
        ...state,
        [action.payload.key]: action.payload.value,
        page: 0,
      };
    case FiltersStoreKind.UPDATE_SIZE:
      return {
        ...state,
        size: action.payload,
        page: 0,
      };
    case FiltersStoreKind.UPDATE_PAGE:
      return {
        ...state,
        page: action.payload,
      };
    case FiltersStoreKind.UPDATE_SEARCH_TERM:
      return {
        ...state,
        searchTerm: action.payload,
        page: 0,
      };
    case FiltersStoreKind.UPDATE_SORTING:
      return { ...state, sort: action.payload };
    default:
      throw new Error();
  }
};

export default filtersStore;
